import { BaseSchedulerControl } from "../base.scheduler.control";

export abstract class BaseWorkerControl extends BaseSchedulerControl {
}